import TrezorLockIcon from './TrezorLockIcon'

export default TrezorLockIcon
